import React from 'react'
import * as innerLayoutStyles from './styles.module.css'

const InnerLayout = ({ children }) => {
    return <div className={innerLayoutStyles.container}>{children}</div>
}

export default InnerLayout
